import styled, { css } from 'styled-components';

export const NavWrapper = styled.div`
  margin: 16px 0;
  width: 100%;
`;

export const NavbarContainer = styled.div`
  ${({ theme }) => css`
    align-items: end;
    background: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px 8px 0px 0px;
    display: flex;
    padding-top: 8px;
    width: 100%;
  `};
`;

export const NavbarImage = styled.img`
  height: 32px;
  user-select: none;
  -webkit-user-drag: none;
`;

export const InputContainer = styled.form``;

const sidePadding = 24;

export const InputWrapper = styled.div`
${({ theme, $hasError, $selectDomain }) => css`
    align-items: start;
    background: ${theme.v2.colors.white.primary};
    border-radius: 0px 0px 8px 8px;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    min-height: ${$selectDomain && '98px'};
    padding-bottom: ${$hasError && '0'};
    padding: 16px ${sidePadding}px;
    position: relative;
    text-align: left;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: center;
      flex-direction: column;
    }
  `};

  div > {
    width: 100%;
  }
`;

export const SelectWrapper = styled.div`
  width: 100%;

  div > {
    width: 100%;
  }
`;

export const AutoCompleteInputWrapper = styled.div`
`;

export const TextFieldWrapper = styled.div`
  ${({
    theme, $beforeContent, $selectDomain,
  }) => css`
    display: flex;
    position: relative;
    width: 100%;
    max-width: 685px;

    > div > div {
      padding-right: ${$selectDomain ? '' : '180px'};
      position: relative;

      &:before {
        color: ${theme.v2.colors.neutral.lowMedium};
        content: '${$beforeContent}';
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        line-height: ${theme.v2.font.lineHeight.text};
        position: absolute;
        right: 16px;
        top: 19px;
      }
    }


    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      > div > div {
        padding-right: 16px;
        padding-bottom: 24px;

        &:before {
          bottom: 16px;
          top: auto;
        }
      }
    }
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: 16px;
    width: 70px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin-top: 0;
      width: auto;
    }
  `};
`;

export const BottomText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `};
`;

const textWrapperPadding = 23;
export const AutoComplete = styled.ul`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    height: auto;
    margin: 0px;
    max-height: 140px;
    overflow-y: auto;
    padding: 0px;
    position: absolute;
    top: 80px;
    width: calc(100% - ${textWrapperPadding * 2}px);
    z-index: ${theme.v2.layers.important};

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPrimary};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highDark};
      border-radius: 25px;
      height: 30px;
      width: 8px;
    }
  `}
`;

export const AutoCompleteItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.list};
    padding: 8px 16px;

    &:hover {
      background-color: ${theme.v2.colors.brand.primaryBlue};
      color: ${theme.v2.colors.neutral.highPure};
    }
  `}
`;


export const DomainOkAlert = styled.div`
  ${({ $display }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    gap: 8px;
    max-width: 685px;
    opacity: ${$display ? 1 : 0};
  `};
`;

export const DomainOkAlertRow = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const DomainOkAlertTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: left;
  `}
`;
export const DomainOkAlertDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: left;
  `}
`;

export const InsideWizardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ToggleRow = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 8px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0 16px;
  `}
`;


export const TempDomainInfo = styled.p`
  ${({ theme, $moreTopSpace }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: ${$moreTopSpace ? '24px' : '8px'} 0px 0px 0px;
    padding: 0px;
    text-align: center;
  `}
`;

export const LinkWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 8px 0px 0px 0px;

    >a {
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.regular};
      text-decoration: underline !important;
    }
  `}
`;
